// src/data/trainings.js
const trainings = [
  {
    id: "iso-17025",
    title: "Implementação do SGQ – ISO 17025",
    subtitle: "Acreditação, requisitos e boas práticas para laboratório",
    duration: "≈ 2–4h (ajustável)",
    level: "Intermediário",
    tags: ["ISO 17025", "Acreditação", "Metrologia", "SGQ"],
    route: "/app/apresentacao/iso-17025",
    featured: true,
    description:
      "Estrutura completa com conceitos de metrologia, rastreabilidade, requisitos (4–8) e preparação para avaliação Cgcre/Inmetro.",
  },
  // add more trainings here later
  // {
  //   id: "incerteza",
  //   title: "Incerteza de Medição na Avaliação da Conformidade",
  //   subtitle: "Aplicação prática e decisões com risco",
  //   duration: "≈ 2h",
  //   level: "Intermediário",
  //   tags: ["Incerteza", "Conformidade", "Metrologia"],
  //   route: "/treinamentos/incerteza",
  //   featured: false,
  //   description: "…",
  // },
];

export default trainings;
